const appName = "矩阵世界";

export { appName };
